import React from "react"

interface EmailProps {
  className?: string
  width?: string
  height?: string
  strokeWidth?: string
}

function Email(props: Readonly<EmailProps>) {
  const { className, width, height, strokeWidth } = props
  const cssClassName = className ?? ""
  const cssWidth = width ?? "16"
  const cssHeight = height ?? "16"
  const cssStrokeWidth = strokeWidth ?? "1.5"
  return (
    <span className="anticon">
      <svg
        className={cssClassName}
        width={cssWidth}
        height={cssHeight}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.333 13.6673H4.66634C2.66634 13.6673 1.33301 12.6673 1.33301 10.334V5.66732C1.33301 3.33398 2.66634 2.33398 4.66634 2.33398H11.333C13.333 2.33398 14.6663 3.33398 14.6663 5.66732V10.334C14.6663 12.6673 13.333 13.6673 11.333 13.6673Z"
          stroke="currentColor"
          strokeWidth={cssStrokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3337 6L9.24699 7.66667C8.56032 8.21333 7.43366 8.21333 6.74699 7.66667L4.66699 6"
          stroke="currentColor"
          strokeWidth={cssStrokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default Email
